
//TODO: given that the input to this function is a string, it should probably be located in the string-util file.
export const stringToInt = (input: string): number => {
  return parseInt(input, 10);
}

export const formatSecondsToMinutesAndSeconds = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60) || 0;
  const remainingSeconds = formatSeconds(Math.floor(seconds % 60) || 0);
  const minutesAndSeconds = `${minutes}:${remainingSeconds}`;
  return minutesAndSeconds;
}

export const formatSeconds = (seconds: number) => {
  return seconds < 10 ? `0${seconds}` : `${seconds}`;
}

/** A media duration is only usable once it's a positive, finite number of seconds. */
export const isKnownDuration = (seconds: number): boolean => {
  return Number.isFinite(seconds) && seconds > 0;
}